/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2016, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../lib/@waca/baglass/js/baglass/app/plugins/Button',
	'../../lib/@waca/dashboard-common/dist/ui/react_toolbar/components/Button',
	'react'
], function (BaseClass, Button, React) {
	return class UndoRedoButton extends BaseClass {
		init(props) {
			Object.assign(this, props);
			this.itemSpec.action = this.onPress.bind(this);
			// callback after render
			this.itemSpec.callbacks = {
				registerCallback: this.onRender.bind(this),
				unregisterCallback: () => {}
			};
			this.myRef = React.createRef();
		}

		/**
		 * Method to determine whether the button can be enabled or not
		 */
		canEnable(/*controller*/) {
			return true;
		}

		// To be implemented by concrete class
		onPress() {}

		onRender() {
			this._toggleState(this);
		}

		onStateChange(controller) {
			this._toggleState(this, controller);
		}

		render() {
			return (<Button
				itemSpec={this.itemSpec}
				setSelectedSubMenu={() => {}} //needed by the Button component
			/>);
		}

		_toggleState(plugin, controller) {
			if (plugin) {
				if (controller && this.canEnable(controller)) {
					plugin.enable();
				} else {
					plugin.disable();
				}
			}
		}
	};
});
